import { StepNumber } from 'components'
import './style.scss'

export function SignalStep({ number = 1, description = '' }) {
  return (
    <p className='signal-step'>
      <StepNumber number={number} />
      <span className='step-text'>{description}</span>
    </p>
  )
}
